$(document).ready(function () {

  // header sticky js 
  $(window).scroll(function () {
    let scr = $(window).scrollTop();
    $(".header").removeClass("header-sticky");
    if (scr > 80) {
      $(".header").addClass("header-sticky");
    } else {
      if (screen.width > 991) {
        $(".header").removeClass("header-sticky");
      }
    }
  });

  
// accordion js 
   $(".accordion-box.open .accordion__panel").css("display", "block");

   // Accordion toggle behavior
   $(".accordion__head").on("click", function () {
      const $clickedHeader = $(this);
      const $currentBox = $clickedHeader.closest(".accordion-box");
      const isAlreadyOpen = $currentBox.hasClass("open");

      // Close all panels
      $(".accordion-box").removeClass("open");
      $(".accordion__head").removeClass("active");
      $(".accordion__panel").slideUp();

      // Open clicked panel if it was not already open
      if (!isAlreadyOpen) {
         $currentBox.addClass("open");
         $clickedHeader.addClass("active");
         $currentBox.find(".accordion__panel").slideDown();
      }
   });


  // marquee text carousel 
  $('.custom-marquee .marquee-top').owlCarousel({
      items: 2,
      loop: true,
      infinite: true,
      autoplay: true,
      autoWidth: true,
      autoplaySpeed: 10000,
      slideTransition: 'linear',
      touchDrag: false,
      mouseDrag: false,
      margin: 30,
      dots: false,
      nav: false,
      responsive: {
         0: {
            items: 2,
            margin: 15
         },
         576: {
            items: 3,
            margin: 15
         },
         767: {
            items: 3,
            margin: 15
         },
         991: {
            items: 3,
            margin: 25
         },
         1024: {
            items: 2,
            margin: 25
         },
         1200: {
            items: 2,
            margin: 30
         }
      }
   });

  $('.custom-marquee .marquee-bottom').owlCarousel({
      items: 2,
      loop: true,
      infinite: true,
      autoplay: true,
      autoWidth: true,
      autoplaySpeed: 10000,
      slideTransition: 'linear',
      touchDrag: false,
      mouseDrag: false,
      margin: 30,
      dots: false,
      rtl: !0,
      nav: false,
      responsive: {
         0: {
            items: 2,
            margin: 15
         },
         576: {
            items: 3,
            margin: 15
         },
         767: {
            items: 3,
            margin: 15
         },
         991: {
            items: 3,
            margin: 25
         },
         1024: {
            items: 2,
            margin: 25
         },
         1200: {
            items: 2,
            margin: 30
         }
      }
   });

  $('.banner-icon-slider').owlCarousel({
      items: 5,
      loop: true,
      infinite: false,
      autoplay: true,
      autoWidth: true,
      autoplaySpeed: 10000,
      slideTransition: 'linear',
      touchDrag: false,
      mouseDrag: false,
      margin: 45,
      dots: false,
      nav: false,
      responsive: {
      1300: {
          autoWidth: true,
        },
      1280: {
        items: 4,
        margin: 45,
        autoWidth: true,
      },
      1024: {
        items: 4,
        margin: 35,
      },
      768: {
        items: 3,
        margin: 25,
      },
      480: {
        items: 2,
        margin: 20,
      },
      0: {
        items: 1,
        margin: 15,
      }
    }
  });

  $('.reviewImageSlide').owlCarousel({
      items: 1,
      loop: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 5000,
      touchDrag: true,
      mouseDrag: true,
      dots: true,
      nav: true,
   });

  $('.review-card-slider').owlCarousel({
      items: 3,
      loop: true,
      infinite: true,
      autoplay: false,
      margin: 32,
      autoplaySpeed: 5000,
      touchDrag: true,
      mouseDrag: true,
      dots: true,
      nav: true,
     stagePadding: 32,
      responsive: {
        0: {
      items: 1,
      margin: 16,
      stagePadding: 16,
      nav: true,
      dots: true
    },
    480: {
      items: 1,
      margin: 16,
      stagePadding: 24,
      nav: true,
      dots: true
    },
    768: {
      items: 2,
      margin: 24,
      stagePadding: 24,
      nav: true,
      dots: true
    },
    991: {
            items: 2,
            margin: 24,
           stagePadding: 24,
         },
        1024: {
            items: 2,
            margin: 24,
           stagePadding: 24,
         },
        1100: {
            items: 3,
            margin: 24,
           stagePadding: 24,
           dots: true,
          nav: true,
         },
        
         1441: {
            items: 3,
            margin: 32,
           stagePadding: 32,
           dots: true,
          nav: true,
         }
      }
    });

$('.rating-carousel').owlCarousel({
  items: 1,
  loop: true,
  autoplay: true, // enable autoplay
  autoplayTimeout: 3000, // 3 seconds
  autoplayHoverPause: true,
  nav: false,
  dots: false,
  mouseDrag: true,
  touchDrag: true,
});


  $('.topbar-carousel__slider').owlCarousel({
      loop: true,
      autoplay: true,
      autoplaySpeed: 10000,
      slideTransition: 'linear',
      touchDrag: false,
      mouseDrag: false,
      margin: 25,
      dots: false,
      nav: false,
      autoWidth: true,
      responsive: {
        0: {
          items: 2
        },
        480: {
          items: 3
        },
        768: {
          items: 4
        },
        1024: {
          items: 5
        }
      }
  });

  $('.login-slider').owlCarousel({
      items: 1,
      loop: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 5000,
      touchDrag: true,
      mouseDrag: true,
      dots: true,
      nav: true,
   });

  $('.mega-menu__product-grid').owlCarousel({
      items: 4,
      loop: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      touchDrag: true,
      mouseDrag: true,
      margin: 20,
      dots: false,
      nav: true,
    responsive: {
    0: {
      items: 1  // for mobile devices
    },
    480: {
      items: 2  // small tablets
    },
    768: {
      items: 3  // tablets
    },
    1024: {
      items: 3,
      nav: true,
    },
      1100: {
        items: 4
      }
  }
   });

//   $('.rating-bone').each(function () {
//   var ratingBox = $(this);
//   var countText = ratingBox.find('.rating-count').text().trim();
//   var filledCount = parseFloat(countText.split('/')[0]);

//   // Get stroke color from existing SVG path or default to pink if not found
//   var existingPath = ratingBox.find('svg path').first();
//   var strokeColor = existingPath.attr('stroke') || '#FBCBCC';

//   // Clear any existing stars
//   ratingBox.find('.bone').remove();

//   // Create 5 SVG stars with stroke color
//   for (var i = 0; i < 5; i++) {
//     var star = `
//       <span class="bone">
//         <svg xmlns="http://www.w3.org/2000/svg" width="40" height="17" viewBox="0 0 40 17" fill="none">
//           <path d="${existingPath.attr('d')}" stroke="${strokeColor}" stroke-width="1.15556" fill="none" />
//         </svg>
//       </span>`;
//     ratingBox.prepend(star);
//   }

//   // Fill only the needed number of stars
//   ratingBox.find('.bone svg path').each(function (index) {
//     if (index < Math.round(filledCount)) {
//       $(this).attr('fill', strokeColor);
//     } else {
//       $(this).attr('fill', 'none');
//     }
//   });
// });


  // // ingredient nav pills 
  // $('.ingredient-nav-pills__navs ul li').click(function () {
  //   var index = $(this).data('id');

  //   // Set active tab
  //   $('.ingredient-nav-pills__navs ul li').removeClass('active');
  //   $(this).addClass('active');
  //   $('html, body').animate(
  //   {
  //     scrollTop: $('#ingredient-navScroll').offset().top + 0 
  //   },
  //   500
  // );

  //   // Show corresponding info content
  //   $('.ingredient-nav-pills__navInfo .ingredient-nav-pills__navInfo--inner').hide();
  //   $('.ingredient-nav-pills__navInfo .ingredient-nav-pills__navInfo--inner[data-id="' + index + '"]').fadeIn();
  // });

  $('.ingredient-nav-pills__navs').on('click', 'ul li', function () {
  const index = $(this).data('id');

  /* 1 Active state ------------------------------------------------------- */
  $(this)
    .addClass('active')
    .siblings().removeClass('active');
    
  const headerGap = ($('.header').outerHeight() || 0) + 0; 

  $('html, body').animate(
    { scrollTop: $('#ingredient-navScroll').offset().top - headerGap },
    500
  );

  
  $('.ingredient-nav-pills__navInfo .ingredient-nav-pills__navInfo--inner')
    .hide()
    .filter(`[data-id="${index}"]`)
    .fadeIn();
});



  // Feature review popup 
$('.feature-video-btn').on('click', function () {
  var index = $('.feature-video-btn').index(this);
  $('.featured-review__video-popup').eq(index).css('display', 'flex');
});

$('.feature-popup-close').on('click', function () {
  const popup = $(this).closest('.featured-review__video-popup');
  const iframe = popup.find('iframe');
  iframe.attr('src', iframe.attr('src')); // reset video
  popup.css('display', 'none');
});

$('.featured-review__video-popup').on('click', function (e) {
  if (!$(e.target).closest('.featured-review__video-popup--innerWrap').length) {
    const iframe = $(this).find('iframe');
    iframe.attr('src', iframe.attr('src')); // reset video
    $(this).css('display', 'none');
  }
});


  // masnory grid 
  $('.reviews-grid').masonry({
    itemSelector: '.review-card',
    columnWidth: '.grid-sizer',
    percentPosition: true
  });
});

$(window).on('resize', function () {
  $('.reviews-grid').masonry('layout');
});

// document.querySelectorAll('[data-wow-delay]').forEach(el => {
//   el.removeAttribute('data-wow-delay');
// });

$(window).on('load', function () {
   wow = new WOW({
      offset: 80,
      live: true,
   })
   wow.init();
});












// Function to toggle the read more / read less for any button and associated content
function toggleReadMore(buttonId, contentId) {
  const button = document.getElementById(buttonId);
  const contentBox = document.getElementById(contentId).parentElement; // Get parent container for the content box
  const contentText = document.getElementById(contentId);
  
  // Toggle the 'expanded' class to control the content visibility
  contentBox.classList.toggle('expanded');
  
  // Change the button text depending on whether content is expanded or collapsed
  if (contentBox.classList.contains('expanded')) {
    button.textContent = 'Read Less';
  } else {
    button.textContent = 'Read More';
  }
}

// Add event listeners for both buttons
document.getElementById('readMoreBtn1').addEventListener('click', function() {
  toggleReadMore('readMoreBtn1', 'contentText1');
});

document.getElementById('readMoreBtn2').addEventListener('click', function() {
  toggleReadMore('readMoreBtn2', 'contentText2');
});